// extracted by mini-css-extract-plugin
export default {"title":"TextContent_title__KDOLa","text":"TextContent_text__88qvu"};